import Box from '@mui/material/Box';
import React from 'react';
import { RefreshAnimation } from '../Animations/RefreshAnimation';
import { Button, ButtonProps } from './Button';
import { styled } from '@mui/material/styles';

export type ButtonWithLoaderProps = {
  children: string | React.ReactNode;
  isLoading: boolean;
};

const BoxStyled = styled(Box)(({ theme }) => ({
  transform: 'scale(0.83)',
  marginTop: theme.spacing(3),
  height: theme.spacing(23),
}));

export const ButtonWithLoader: React.FC<ButtonProps & ButtonWithLoaderProps> = ({
  children,
  isLoading,
  ...otherProps
}) => {
  return (
    <Button disabled={isLoading} {...otherProps}>
      {isLoading ? (
        <BoxStyled>
          <RefreshAnimation />
        </BoxStyled>
      ) : (
        <>{children}</>
      )}
    </Button>
  );
};
